<template>
  <g class="svg__legend-group"
    :transform="`translate(${this.$props.x},${this.$props.y})`">
    <line x1="15" x2="65" :y1="line1Y" :y2="line1Y" :stroke="companyStrokeColor"/>
    <text x="75" :y="line1Y+5" :fill="textColor" :font-size="fontSize">
      <template v-if="this.hasOwnProperty('$i18n')">
        {{ $t('company') }}
      </template>
      <template v-else>
        Company
      </template>
    </text>
    <line x1="15" x2="65" :y1="line1Y+20" :y2="line1Y+20" :stroke="indStrokeColor"/>
    <text x="75" :y="line1Y+25" :fill="textColor" :font-size="fontSize">
      <template v-if="this.hasOwnProperty('$i18n')">
        {{ $t('individual') }}
      </template>
      <template v-else>
        Individual
      </template>
    </text>
    <line x1="15" x2="65" :y1="line1Y+40" :y2="line1Y+40"
      :stroke="otherStrokeColor"
      stroke-dasharray="5,5"/>
    <text x="75" y="45" :fill="textColor" :font-size="fontSize">
      <template v-if="this.hasOwnProperty('$i18n')">
        {{ $t('not_specified') }}
      </template>
      <template v-else>
        Not specified
      </template>
    </text>
  </g>
</template>

<script>

export default {
  name: 'DiagramLegend',
  props: ['x', 'y'],
  data () {
    return {
      line1Y: 0,
      textColor: '#2C3E50',
      companyStrokeColor: '#3F88C5',
      indStrokeColor: '#E94F37',
      otherStrokeColor: 'black',
      fontSize: '0.9em'
    }
  }
}
</script>

<style scoped>

</style>
